export const PageSectionHeading = {
  baseStyle: {
    fontSize: '20px',
    marginTop: ['10px', '50px'],
  },
};
